/**
 * apiFetch — Authenticated fetch wrapper.
 * Injects JWT Bearer token from localStorage into every request.
 * Auto-redirects to /login on 401 (expired/invalid token).
 */

import config from './config';

const TOKEN_KEY = 'slam-basketball-token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export default async function apiFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : `${config.API_BASE_URL}${path}`;

  const headers = { ...options.headers };
  const token = getToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Auto-set Content-Type for JSON string bodies
  if (!headers['Content-Type'] && options.body && typeof options.body === 'string') {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(url, { ...options, headers });

  if (res.status === 401) {
    clearToken();
    // Only redirect if we're in a browser context (not SSR)
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
      window.location.href = '/login';
    }
    throw new Error('Session expired');
  }

  return res;
}
